import React from 'react';
import { loginCredientials } from '../../constant';
import './Login.css';
function Login() {
    const currentYear = new Date().getFullYear();
    const adminLogin = () => {
        window.location.href = `https://login.microsoftonline.com/${loginCredientials.tenantId}/oauth2/v2.0/authorize?
        client_id=${loginCredientials.clientId}
        &response_type=code
        &redirect_uri=${window.location.origin}/hivelogin
        &scope=openid
        &response_mode=query
        &state=12345`;
    };
    return (
        <div className="container-fluid">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-6 align-self-center">
                        <div className="row justify-content-center align-self-center">
                            <div className="col-md-6">
                                <div className="text-center">
                                    <img src="/Images/hivelogo.svg" className="login-custom-logo-size" />
                                    <p className="urbanist-medium font-25 my-4">
                                        Hi Team, 
                                        <span className="urbanist-bold">
                                            Welcome to <span className="login-text-orange">HIVE</span>
                                        </span>
                                    </p>
                                    <button
                                        onClick={() => {
                                            adminLogin();
                                        }}
                                        type="button"
                                        className="btn hive-btn-primary urbanist-bold login-btn-style w-100"
                                    >
                                        Login
                                    </button>
                                </div>
                                <div className="border-top mt-4 d-flex justify-content-between align-items-center">
                                    <label className="medium-text font-13 mt-3 login-label-color-1">For issues &amp; concerns</label>
                                    <label className="medium-text font-13 mt-3">Hivesupport@avasoft.com</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 align-self-center">
                        <div className="justify-content-center">
                            <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators login-custom-alignment login-custom-carousel-indicators">
                                    <button
                                        type="button"
                                        data-bs-target="#carouselExampleIndicators"
                                        data-bs-slide-to="0"
                                        className="active"
                                        aria-label="Slide 1"
                                    />
                                    <button
                                        type="button"
                                        data-bs-target="#carouselExampleIndicators"
                                        data-bs-slide-to="1"
                                        aria-label="Slide 2"
                                    />
                                    <button
                                        type="button"
                                        data-bs-target="#carouselExampleIndicators"
                                        data-bs-slide-to="2"
                                        aria-label="Slide 3"
                                    />
                                    <button
                                        type="button"
                                        data-bs-target="#carouselExampleIndicators"
                                        data-bs-slide-to="3"
                                        aria-label="Slide 4"
                                    />
                                </div>
                                <div className="carousel-inner login-custom-height">
                                    <div className="carousel-item active mt-5">
                                        <img
                                            src="/Images/Employee Relations.svg"
                                            className="d-block login-carousel-size m-auto mt-5"
                                            alt="Employee relations"
                                        />
                                        <p className="urbanist-bold font-20 my-3 text-center">Employee Relations</p>
                                        <p className="medium-text font-14 login-text-color text-center">
                                            Our efforts to create and maintain a positive relationship with our team members.
                                        </p>
                                    </div>
                                    <div className="carousel-item mt-5 ">
                                        <img
                                            src="/Images/Talent-acquisition.svg"
                                            className="d-block login-carousel-size m-auto mt-5"
                                            alt="Employee relations"
                                        />
                                        <p className="urbanist-bold font-20 my-3 text-center">Talent Acquisition</p>
                                        <p className="medium-text font-14 login-text-color text-center">
                                            The process of identifying and acquiring skilled people to meet our organizational needs.
                                        </p>
                                    </div>
                                    <div className="carousel-item mt-5">
                                        <img
                                            src="/Images/centralized employee recrods.svg"
                                            className="d-block login-carousel-size m-auto mt-5"
                                            alt="Employee relations"
                                        />
                                        <p className="urbanist-bold font-20 my-3 text-center">Centralized Employee Records</p>
                                        <p className="medium-text font-14 login-text-color text-center">
                                            Maintaining all the details associated with team members in a centralized area.
                                        </p>
                                    </div>
                                    <div className="carousel-item mt-5">
                                        <img
                                            src="/Images/leavemanagement.svg"
                                            className="d-block login-carousel-size m-auto mt-5"
                                            alt="Employee relations"
                                        />
                                        <p className="urbanist-bold font-20 my-3 text-center">Leave Management</p>
                                        <p className="medium-text font-14 login-text-color text-center">
                                            Manages the leaves and its approval and tracking of remaining leaves of team members.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 fixed-bottom bg-dark">
                        <p className="text-center mb-0 p-2 text-white">© {currentYear} Avasoft Inc.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
